import { Controller } from '@hotwired/stimulus'


export default class extends Controller {
  static targets = ['select', 'checkboxGroup']

  connect() {
    console.log('Example controller connected – on page load!')
    this.updateCheckboxes()
  }

  updateCheckboxes() {
    const selectedPackageId = this.selectTarget.value

    this.checkboxGroupTargets.forEach(group => {
      const groupPackageId = group.dataset.packageId
      group.style.display = groupPackageId === selectedPackageId ? 'flex' : 'none'
    })
  }
}